type LabelProps = {
    children?  : string
    padding?   : string
    size?      : string
    fontWeight? : string
    color? : string
    textAlign? : CanvasTextAlign
    margin? : string 
    wrap?: boolean
}

const Label: React.FC<LabelProps> = ({
    children="", 
    padding="0px 20px", 
    size="large", 
    fontWeight="500", 
    color="#565656",
    textAlign = "left",
    margin = "",
    wrap = false
}) => {
    if (color === "") color = "#565656"
    return <div style={{
        margin:margin,
        textAlign: textAlign,
        padding: padding,
        color:color, 
        fontSize:size, 
        fontWeight:fontWeight,
        textWrap: wrap ? "wrap" : "nowrap"}}>
        {children}
    </div>
}

export default Label